<template>
  <div class="custom-radio-input" :class="orientation">
    <div v-for="option in options" class="option">
      <button
        :id="id(option)"
        :class="{ checked: checked(option) }"
        :disabled="disabled"
        @click="() => handleOptionChecked(option)"
        type="button"
      >
        <span></span>
      </button>
      <label :for="id(option)">
        {{ name(option) }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [Number, String],
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    namedBy: {
      type: [String, null],
      default: null,
    },
    identifiedBy: {
      type: [String, null],
      default: null,
    },
    orientation: {
      type: String,
      default: 'vertical',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    id (option) {
      return this.identifiedBy ? option[this.identifiedBy] : option;
    },

    name (option) {
      return this.namedBy ? option[this.namedBy] : option;
    },

    checked (option) {
      return this.value === this.id(option);
    },

    handleOptionChecked (option) {
      this.$emit('checked', this.id(option));
    },
  },
};
</script>

<style lang="scss">
@import '../../../sass/variables';
@import '../../../sass/mixins';

.custom-radio-input {
  display: flex;
  flex-direction: column;
  gap: 1rem;

  &.horizontal {
    flex-direction: row;
    justify-content: center;
  }

  .option {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    label {
      @include salesflow-subtitle($color: $salesflow-font-dark);
      font-family: 'Inter';

      margin-bottom: 0px;
    }

    button {
      width: 1rem;
      height: 1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0px;
      border-radius: 100%;
      border: 0px;
      outline: 0px;
      background: #d9d9d9;

      span {
        width: calc(1rem - 1px);
        height: calc(1rem - 1px);
        border-radius: 100%;
        background: white;
      }

      &.checked {
        background: $salesflow-primary;

        span {
          width: 0.5rem;
          height: 0.5rem;
        }
      }

      &:disabled {
        cursor: inherit;
      }
    }
  }
}

</style>
